import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actions from './actions.js'

const modals = {}

class Modals extends Component {
  render() {
    return (
      <div>
        {Object.keys(this.props.modals).map((name) => {
          const ModalComponent = modals[name]
          const modal = this.props.modals[name]
          return (
            <ModalComponent
              key={`${name}_${modal.version}`}
              isOpen={modal.open}
              closing={modal.closing}
              closeModal={(force) => this.props.closeModal({ name, force })}
              cancelClose={() => this.props.cancelClose({ name })}
              {...modal.initialState}>
            </ModalComponent>
          )
        })}
      </div>
    )
  }
}

export function registerModal(name, component) {
  modals[name] = component
}

export default connect(
  (state) => ({ modals: state.modals }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(Modals)
